export default __webpack_public_path__ + "static/media/placeholder_portfolio04-jp-mobile.b5e9ee34.png";